import { IOpenVillageBanner } from '../../types/banner';
import * as React from 'react';
import * as styles from './OpenVillageBanner.css';
import { ArticleParagraph1 } from '@cian/ui-kit';

interface IOpenVillageBannerProps extends IOpenVillageBanner {
  target?: React.HTMLAttributeAnchorTarget;
}

export const OpenVillageBanner: React.FC<IOpenVillageBannerProps> = ({ title, description, link, target }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{title}</div>
      <div className={styles['open-village-logo']} />
      <div className={styles['description']}>{description}</div>
      {link && (
        <div>
          <a href={link} className={styles['link']} target={target} rel="noreferrer">
            <ArticleParagraph1 color="text-main-default" display="inline">
              Подробнее
            </ArticleParagraph1>
          </a>
        </div>
      )}
    </div>
  );
};
